import data from '../content/recipes.json';

export interface Recipe {
  slug: string;
  title: string;
  summary: string;
  image: string;
  imageAlt: string;
  illustrative: boolean;
  appliance: string;
  mealType: string;
  prepMinutes: number;
  cookMinutes: number;
  servings: number;
  ingredients: { amount: string; name: string }[];
  steps: string[];
  tips: string[];
}

export const recipes: Recipe[] = data.recipes;
export const appliances = data.appliances;
export const mealTypes = data.mealTypes;
export const applianceLabel = (id: string) => appliances.find(item => item.id === id)?.label ?? id;
export const mealLabel = (id: string) => mealTypes.find(item => item.id === id)?.label ?? id;
export const totalMinutes = (recipe: Recipe) => recipe.prepMinutes + recipe.cookMinutes;

export function normalizeVietnamese(text: string): string {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLocaleLowerCase('vi').trim();
}

export interface RecipeFilters { q: string; appliance: string; meal: string }

export function recipeListReturnPath(from: unknown): string {
  return typeof from === 'string' && /^\/recipes\/?(?:\?[^#]*)?$/.test(from) ? from : '/recipes/';
}

export function filtersFromParams(params: URLSearchParams): RecipeFilters {
  const appliance = params.get('appliance') ?? '';
  const meal = params.get('meal') ?? '';
  return {
    q: params.get('q') ?? '',
    appliance: appliances.some(item => item.id === appliance) ? appliance : '',
    meal: mealTypes.some(item => item.id === meal) ? meal : '',
  };
}

export function filterRecipes(items: Recipe[], filters: RecipeFilters): Recipe[] {
  const words = normalizeVietnamese(filters.q).split(/\s+/).filter(Boolean);
  return items.filter(recipe => {
    if (filters.appliance && recipe.appliance !== filters.appliance) return false;
    if (filters.meal && recipe.mealType !== filters.meal) return false;
    const searchable = normalizeVietnamese([recipe.title, recipe.summary, ...recipe.ingredients.map(item => item.name)].join(' '));
    return words.every(word => searchable.includes(word));
  });
}
